'use client';

import React, { useRef } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Slider } from '@/widgets/Slider';
import type { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { widgetScheduleConfig } from '@/shared/config/tests/e2e/widgets/schedule';
import { classNames } from '@/shared/lib/classnames/classnames';
import { getFormattedDate } from '@/shared/lib/date/getFormattedDate';
import { ScheduleItem } from './ScheduleItem';
import type { ScheduleProps } from '../model/types';
export const Schedule: React.FC<ScheduleProps> = ({
  schedule,
  // @todo: явно чот не то с пропсами
  onScheduleClick,
  emptyTimeslots,
  onScheduleItemClick,
  hasOnlineBookingInMedcenter,
  limitVisualItems = 0
}) => {
  const currentLocale = useLocale();
  const t = useTranslations('doctor.schedule');
  const containerRef = useRef<HTMLDivElement>(null);
  const today = new Date();
  const currentDay = today.getDay() || 7;
  const getDateToFormat = (dayOffset: number) => {
    const date = new Date();
    date.setDate(today.getDate() + dayOffset);
    return date.toString();
  };
  const formatDate = (dayOffset: number) => {
    return getFormattedDate(getDateToFormat(dayOffset), {
      format: 'DD MMM',
      locale: currentLocale as LanguageCodeEnum
    });
  };
  const getDayName = (dayOffset: number) => {
    return getFormattedDate(getDateToFormat(dayOffset), {
      format: 'dd',
      locale: currentLocale as LanguageCodeEnum,
      capitalizeFirst: true
    });
  };
  const getDayOffset = (scheduleDay: number) => {
    const diff = scheduleDay - currentDay;
    return diff >= 0 ? diff : 7 + diff;
  };
  if (schedule.length === 0) {
    return null;
  }
  const sortedSchedule = [...schedule].sort((a, b) => {
    const offsetA = getDayOffset(a.day);
    const offsetB = getDayOffset(b.day);
    return offsetA - offsetB;
  });
  const displayedSchedule = limitVisualItems > 0 && sortedSchedule.length > limitVisualItems ? sortedSchedule.slice(0, limitVisualItems) : sortedSchedule;
  const showViewAllButton = limitVisualItems > 0 && sortedSchedule.length > limitVisualItems;
  return <Slider ref={containerRef} itemTag="button" testId={widgetScheduleConfig.ids.scheduleWidget} data-sentry-element="Slider" data-sentry-component="Schedule" data-sentry-source-file="Schedule.tsx">
      <div className="flex items-center gap-2">
        {displayedSchedule.map(item => {
        const dayOffset = getDayOffset(item.day);
        const isToday = item.day === currentDay;
        return <ScheduleItem key={item.day} item={item} formattedDate={formatDate(dayOffset)} isToday={isToday} dayName={getDayName(dayOffset)} hasOnlineBookingInMedcenter={hasOnlineBookingInMedcenter} emptyTimeslots={emptyTimeslots} onClick={onScheduleItemClick ? () => onScheduleItemClick(item) : onScheduleClick} />;
      })}
        {showViewAllButton && <button className={classNames('flex w-27 cursor-pointer flex-col rounded-2lg border border-solid px-2 py-[18px] hover:border-primary')} onClick={onScheduleClick}>
            <div className="flex h-full flex-col text-left">
              <p className="text-sm text-additionalBlue">{t('viewAllDates')}</p>
            </div>
          </button>}
      </div>
    </Slider>;
};